module.exports = __webpack_public_path__ + "img/product_service21.47513d84.png";